import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  cezanneCompanySyncService,
  CezanneCompanySyncRequest,
  CezanneCompanySyncResult,
} from '@aslanpay/portal-common-lib';

/**
 * Synchronously reads a Cezanne tenant using directly-supplied credentials - nothing is persisted server-side,
 * so the full result (or an error) comes back from this one call, no polling required.
 */
const useCezanneCompanySync = ({
  onSuccess,
  onError,
}: UseMutationOptions<CezanneCompanySyncResult, Error, CezanneCompanySyncRequest>) => {
  return useMutation<CezanneCompanySyncResult, Error, CezanneCompanySyncRequest>(
    (request) => cezanneCompanySyncService.sync(request),
    { onSuccess, onError }
  );
};

export default useCezanneCompanySync;
